<h3 mat-dialog-header>Data Cleaning / Scrubbing</h3>
<div mat-dialog-content style = "min-height:500px">
<sf-form style = "min-height:525px"  [schema]="scrubberSchema"  [model]="scrubberModel" (onChange)="checkValue($event.value)" class = "top-margin"></sf-form>
</div>
<div mat-dialog-actions style = "height: 50px;">
     <span class = "middle-fill"></span> 
       <button  mat-button mat-flat-button color = "primary" (click) = "submit()">Save</button> &nbsp; 
     <button mat-button mat-flat-button color = "primary" mat-dialog-close>Cancel</button>
    </div>